import { Button, Col, Form, Input, InputNumber, Row, Select, Space } from 'antd';
import { useEffect, useRef, useState, } from 'react'
import { httpGet } from '../../../utils/api/fetchApi';
import AntDraggableModal from '../../../utils/extend/AntDraggableModal';
import WebEditUniversal, { WEUExtendPropsType } from '../../system/WebEditUniversalNewEx';
import getList from '../../universal/getList';
import systemConfig from '../../../config/systematic';
import WebProductFormList from '../../generalComponents/WebProductFormList';


export default function TakeStockOrderEdit(props: any) {
    const [form] = Form.useForm(); //form 
    const { data } = props;
    const ref = useRef<any>(undefined);
    const [deleteData,setDeleteData]=useState<any>();

    const [formList,setFormList]=useState<any>({formName:"takeStockProducts",form,type:data.type,ref,setDeleteData,isEdit:true})



   

    /** 后端数据Service */
    let wmService: any = systemConfig.wmService;
    const handleOk = (e: any) => {
        ref.current.handleOk();
    };
    const handleCancel = (e: any) => {
        ref.current.handleCancel();
    };

    let extendProps: WEUExtendPropsType = {
        ...props,
        form,
        mountDataOptions:{
            userMount: {
                isEmployees: true,
                isDept:true,
                isUserAreas:true
            }
           },
        apiId: 'takeStockOrder',
        formListName: "takeStockProducts",
    };
    useEffect(() => {
        if (ref.current) {
            // eslint-disable-next-line react-hooks/exhaustive-deps
            wmService = ref.current.wmService;
        }
       
        const fetchData = async () => {
        }
        fetchData()
    }, [])


 
    return (
        <>
            <WebEditUniversal totalData={deleteData} ref={ref} props={extendProps}></WebEditUniversal>
            <AntDraggableModal
                title={(data.type === 'NEW' ? '新增' : '编辑') + '盘点单'}
                open={true}
                okText='确定'
                cancelText='取消'
                onOk={handleOk}
                onCancel={handleCancel}
                closable={false}
                maskClosable={false}
                width={"55%"}
            >
                <Form
                    form={form}
                    name="Edit"
                    onFinish={handleOk}
                 
                >
                    <Row >
                        <Col span={12}>
                            <Form.Item
                                label="id"
                                name="id">
                                <Input disabled={true} />
                            </Form.Item>
                        </Col>

                       
                       
                            <WebProductFormList props={formList}></WebProductFormList>
                    </Row>
                </Form>
            </AntDraggableModal>

        </>
    )
}
